module.exports = __webpack_public_path__ + "static/news2-pic1-091e23a125988122cd34b2570278011c.jpg";